/*
 * Filename: d:\projects\AutoFiFront\src\Content\FilterSelected\FilterSelected.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Wednesday, January 18th 2023, 2:49:37 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */

import { MouseEventHandler } from "react";
import styles from "Content/Filters/TextFilter/TextFilterSelected/TextFilterSelected.module.css";
import { AiOutlineClose } from 'react-icons/ai';
import FilterIconReset from "Theme/Component/FilterIconReset";

type FilterSelectedProps = {
    selected: string,
    function: MouseEventHandler<SVGElement>,
    asFollower: boolean,
    themeColor: string,
};

function FilterSelected(props:FilterSelectedProps){

    return (
        <div className={`${styles.selected_value}`}>
            <div className={`${styles.selected_text}`}>
                {props.selected}
            </div>
            {props.asFollower ? null : <FilterIconReset bgColor={props.themeColor}><AiOutlineClose className={`${styles.icon_reset}`} onClick={props.function}/></FilterIconReset> }
        </div>
    );
}

export default FilterSelected;
